// extracted by mini-css-extract-plugin
module.exports = {"buttonContainer":"DeleteMerchConfirmModal_buttonContainer__3I7Wh","buttonSpace":"DeleteMerchConfirmModal_buttonSpace__1FrDH"};